import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/motion";
import { CtaBand } from "../components/shared";
import { openCookieBanner, readConsent } from "../consent";

/* Pagina Cookie: elenco reale di cookie, storage e servizi di terze parti
   (audit del 2026-10) e gestione delle preferenze tramite banner. */
export default function Cookie() {
  const c = typeof window !== "undefined" ? readConsent() : null;
  return (
    <>
      <section className="sec" style={{ paddingTop: 140 }} data-testid="cookie-page">
        <div className="wrap" style={{ maxWidth: 900 }}>
          <Reveal>
            <p className="kick">Cookie</p>
            <h1 className="h2" style={{ marginBottom: 34 }}>Cookie Policy</h1>
          </Reveal>
          <Reveal delay={0.05}>
            <div style={{ color: "var(--muted)", display: "grid", gap: 22 }} data-testid="cookie-content">
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Cosa sono i cookie</p>
              <p style={{ margin: 0 }}>
                I cookie sono piccoli file che i siti salvano sul dispositivo dell'utente per garantirne il funzionamento o raccogliere informazioni sulla navigazione. Insieme ai cookie, qui descriviamo anche le altre forme di archiviazione locale (localStorage) e i servizi di terze parti caricati dal sito.
              </p>

              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Elenco di cookie, storage e servizi di terze parti (audit 2026-10)</p>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14.5 }} data-testid="cookie-table">
                  <thead>
                    <tr style={{ textAlign: "left" }}>
                      <th style={{ padding: "8px 12px 8px 0" }}>Nome / Strumento</th>
                      <th style={{ padding: "8px 12px" }}>Fornitore</th>
                      <th style={{ padding: "8px 12px" }}>Finalità</th>
                      <th style={{ padding: "8px 12px" }}>Tipo e durata</th>
                    </tr>
                  </thead>
                  <tbody style={{ borderTop: "1px solid var(--line)" }}>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>Nessun cookie HTTP</td>
                      <td style={{ padding: "10px 12px" }}>-</td>
                      <td style={{ padding: "10px 12px" }}>Il sito non installa cookie di profilazione né analitici.</td>
                      <td style={{ padding: "10px 12px" }}>Tecnico — non presente</td>
                    </tr>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>orion-cookie-consent</td>
                      <td style={{ padding: "10px 12px" }}>Orion Security (gestito da questo sito)</td>
                      <td style={{ padding: "10px 12px" }}>Ricordare le scelte fatte nel banner cookie.</td>
                      <td style={{ padding: "10px 12px" }}>localStorage tecnico — fino alla cancellazione (rifiuto: 6 mesi)</td>
                    </tr>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>keplero-device-id</td>
                      <td style={{ padding: "10px 12px" }}>Keplero AI (chat)</td>
                      <td style={{ padding: "10px 12px" }}>Identificare il dispositivo per la sessione di chat e mantenere la conversazione.</td>
                      <td style={{ padding: "10px 12px" }}>localStorage tecnico — fino alla cancellazione</td>
                    </tr>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>i18nextLng</td>
                      <td style={{ padding: "10px 12px" }}>Keplero AI (chat)</td>
                      <td style={{ padding: "10px 12px" }}>Ricordare la lingua dell'interfaccia della chat.</td>
                      <td style={{ padding: "10px 12px" }}>localStorage tecnico — fino alla cancellazione</td>
                    </tr>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>Chat Keplero (script)</td>
                      <td style={{ padding: "10px 12px" }}>Keplero AI — bundle.keplero.ai, v2.api.keplero.ai</td>
                      <td style={{ padding: "10px 12px" }}>Assistente virtuale per richieste e informazioni. Usa solo archiviazione tecnica; per la propria interfaccia può caricare il font "Onest" da Google Fonts.</td>
                      <td style={{ padding: "10px 12px" }}>Servizio tecnico — attivo su ogni pagina</td>
                    </tr>
                    <tr style={{ borderTop: "1px solid var(--line)" }}>
                      <td style={{ padding: "10px 12px 10px 0" }}>Cloudflare Insights</td>
                      <td style={{ padding: "10px 12px" }}>Cloudflare (piattaforma di hosting/CDN)</td>
                      <td style={{ padding: "10px 12px" }}>Beacon tecnico di monitoraggio delle prestazioni del sito, senza cookie.</td>
                      <td style={{ padding: "10px 12px" }}>Tecnico — nessun archivio lato utente</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p style={{ margin: 0, fontSize: 14 }}>
                I font tipografici del sito (Archivo e Karla) sono ospitati sul sito stesso: nessuna chiamata a Google Fonts da parte del sito. Non usiamo strumenti statistici né pubblicitari.
              </p>

              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Gestione delle preferenze</p>
              <p style={{ margin: 0 }}>
                Il banner in basso ti permette di <strong>accettare tutti</strong> i cookie non tecnici, di <strong>rifiutarli</strong> (anche chiudendo con la X: equivale al rifiuto) o di <strong>personalizzare</strong> le categorie (statistiche e servizi di terze parti). Nessuna casella è preselezionata e lo scorrimento della pagina non vale come consenso. Se rifiuti, il banner non verrà riproposto per 6 mesi. Puoi cambiare idea in qualsiasi momento:
              </p>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                <button type="button" className="btn dark sm" onClick={openCookieBanner} data-testid="cookie-open-prefs">
                  Personalizza le preferenze
                </button>
                {c && (
                  <span style={{ fontSize: 14 }} data-testid="cookie-current-choice">
                    Scelta attuale: {c.esito === "rifiutato" ? "rifiuto" : c.esito === "accettato" ? "accettazione" : "-"} (statistiche: {c.statistiche ? "sì" : "no"}, terze parti: {c.terze ? "sì" : "no"})
                  </span>
                )}
              </div>
              <p style={{ margin: 0, fontSize: 14 }}>
                Puoi anche cancellare l'archiviazione locale in qualsiasi momento dalle impostazioni del tuo browser. Per il trattamento dei dati inviati tramite i moduli vedi la <Link to="/privacy">Privacy Policy</Link>.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand testid="cookie-cta" />
    </>
  );
}
